module.exports = __webpack_public_path__ + "img/selected4-min.f9ce1a8a.png";